define(function(require) {
	const IpsModel = require('civicsBase/ipsModelCollection');
	const Builder = require('civicsUtils/buildUrlParameters');
	const logger = require('civicsUtils/application/logger');

	return IpsModel.extend({
		instrumentType:null,
		urlRoot:'/delegate/civics-api/api/cdr/applicationtypes/',
		url:function(){
			var u = '';
			if(this.instrumentType!=null){
				u = this.urlRoot+this.instrumentType;

				if (this.recordTypeId != null)
					u += "/" + this.recordTypeId;

				if (this.urlParameters) {
					u += Builder.buildUrlParameters(this.urlParameters)
				}

				if (this.removePageLimit) {
					if (u.indexOf('?') >= 0) {
						u += '&Page=[{Max:0}]';
					} else {
						u += '?Page=[{Max:0}]';
					}
				}
			}
			return u;
		},
		parse: function (response) {
			let ret = response.data;
			if (ret && ret.length > 0) {
				ret.forEach(el => {
					if (el.primarySiteType == 0) {
						el.primarySiteType = 3;
						logger.logError('Primary Site Type erroneously set to 0 for ' + this.instrumentType + ' ' + this.recordTypeId + '. Changed to 3 (Address and Parcel Allowed). Error raised from application_type_collection');
					}
				});
				
			}
			return ret;
		}
	});
});
